import React, { ComponentProps, FC } from 'react';
import { useTranslation } from '@locales/useTranslation.hook';
import { Tab } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { PlcColor } from '@styles/colors';
import classnames from 'classnames';
import { PlcSingleTabProps, PlcSingleTabSeoProps } from '../Tab.types';

const StyledTab = withStyles({
  root: {
    '& p': {
      fontWeight: 'bold !important',
    },
    maxWidth: 300,
    opacity: 1,
    textTransform: 'none',
  },
  selected: {
    '& p': {
      color: PlcColor.BLACK,
    },
  },
})(Tab);

function truncate(str: string, n: number) {
  return str.length > n ? `${str.substr(0, n - 1)}...` : str;
}

type Props = ComponentProps<typeof Tab> & Pick<PlcSingleTabProps, 'labelColor' | 'notI18n'> & PlcSingleTabSeoProps;

const MeteoSingleTabButton: FC<Props> = ({ label, labelColor, notI18n, variant, ...rest }) => {
  const splitedLabel = label && typeof label === 'string' ? label.split(' ') : [];
  const labelJson = !notI18n && splitedLabel && splitedLabel.length > 0 ? (splitedLabel.shift() as string) : '';
  const i18nKeyNs = !notI18n && label && typeof label === 'string' ? labelJson.split('.')[0] : 'common';
  const { t } = useTranslation(i18nKeyNs);

  const finalLabel = typeof label === 'string' && !notI18n ? t(labelJson) : labelJson;
  const rootClassName = classnames('single-tab-button');

  // S'il existe un sublabel collé au label
  if (splitedLabel && splitedLabel.length > 1) {
    const filtered =
      splitedLabel && splitedLabel.length > 1 ? splitedLabel.filter((x) => x !== undefined && x !== 'undefined') : [];
    const subLabel = splitedLabel && splitedLabel.length > 1 ? filtered.join(' ') : '';

    return (
      <StyledTab
        className={rootClassName}
        label={
          <h2>
            {finalLabel}
            {subLabel && <p style={{ fontWeight: 'normal', paddingTop: '5px' }}>{truncate(subLabel, 50)}</p>}
          </h2>
        }
        style={labelColor ? { color: labelColor } : undefined}
        {...rest}
      />
    );
  }

  // SEO H1-h4 specificity
  if (variant && variant === 'h2') {
    return (
      <StyledTab
        className={rootClassName}
        label={<h2>{finalLabel}</h2>}
        style={labelColor ? { color: labelColor } : undefined}
        {...rest}
      />
    );
  }

  return (
    <StyledTab
      className={rootClassName}
      label={finalLabel}
      style={labelColor ? { color: labelColor } : undefined}
      {...rest}
    />
  );
};

export { MeteoSingleTabButton };
